// extracted by mini-css-extract-plugin
export default {"address-form":"AddressForm_address-form__tqkq4","address-form-btn-container":"AddressForm_address-form-btn-container__IUW6j","address-form-btn":"AddressForm_address-form-btn__GF9KZ"};